export const baseUrl = "https://www.srgoool.com.br";

export function arrayWrap(obj) {
	if (Array.isArray(obj)) {
		return obj;
	}
	return [ obj ];
}

export function callserverSingle(url, params, onsuccess, onerror) {
	params = params || {};
	let method = "GET";
	let body = undefined;

	if (Object.keys(params).length > 0) {
		method = "POST";
		body = JSON.stringify(params);
	}
	fetch(baseUrl + "/v1.3a/" + url, {
		method: method,
		mode: "cors",
		headers: {
			"Content-Type": "application/json"
		},
		body: body
	})
		.then(res => res.json())
		.then(
			(result) => {
				onsuccess(result);
			},
			(error) => {
				onerror(error);
			}
		)
}

export function callserver(requestList, onsuccess, onerror) {
	fetch(baseUrl + "/v1.3a/batch", {
		method: "POST",
		mode: "cors",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify(requestList)
	})
		.then(res => res.json())
		.then(
			(result) => {
				onsuccess(result);
			},
			(error) => {
				onerror(error);
			}
		)
}

export function fmtPercent(p) {
	p = parseFloat(p);
	if (isNaN(p)) {
		return "";
	}
	if (p < 10) {
		return p.toFixed(1).replace('.', ',').replace(/,0$/,'');
	}
	return p.toFixed(0);
}

export function fmtCurrency(p) {
	p = parseFloat(p);
	if (isNaN(p)) {
		return "";
	}
	return p.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
}

export function fmtNumber(p, digits) {
	digits = digits || 0;
	p = parseFloat(p);
	if (isNaN(p)) {
		return "";
	}
	return p.toFixed(digits).replace('.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
}

export function downloadId(id) {
	const url = baseUrl + "/v1.3a/download?id=" + id;
	let win = null;
	try {
		win = window.open(url);
	} catch(e) {
	}
	if (!win) {
		let iframe = document.createElement("iframe");
		iframe.setAttribute("src", url + "&force_download=1");
		iframe.style.display = "none";
		iframe.style.position = "absolute";
		iframe.style.top = "0";
		iframe.style.left = "-100px";
		iframe.style.width = "100px";
		document.body.appendChild(iframe);
	}
}

function pad0(s, cnt) {
	cnt = cnt || 2;
	s = s + "";

	while (s.length < cnt) {
		s = "0" + s;
	}
	return s;
}

export function fmtData(val, emptyText) {
	emptyText = emptyText || "";
	if (!val || /0000-00-00/.test(val)) {
		return emptyText;
	}

	var date = new Date(val);

	return pad0(date.getDate()) + "/" + pad0(date.getMonth() + 1) + date.getFullYear();
}

export function fmtDataHora(val, emptyText) {
	emptyText = emptyText || "";
	var data = /([0-9]+)-([0-9]+)-([0-9]+)[ T]([0-9]+):([0-9]+)/.exec(val);
	if (!val || /0000-00-00/.test(val) || !data) {
		return emptyText;
	}
	return pad0(data[3]) + "/" + pad0(data[2]) + " " + pad0(data[4]) + "h" + pad0(data[5]);
}
